/**
 * 收费处路由
 */
const basePath = 'dashboard'
var operatingTheaterRoutes = [{
  path: `${basePath}/inpatient_leave_query`,
  name: `${basePath}/inpatient_leave_query`,
  meta: {
    title: '出院病人查询',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/inpatient_leave_query.vue'], resolve)
}, {
  path: `${basePath}/income-for-outpatient`,
  name: `${basePath}/income-for-outpatient`,
  meta: {
    title: '门诊日结查询',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/income-for-outpatient.vue'], resolve)
}, {
  path: `${basePath}/income-for-inpatient`,
  name: `${basePath}/income-for-inpatient`,
  meta: {
    title: '住院日结查询',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/income-for-inpatient.vue'], resolve)
}, {
  path: `${basePath}/daily-fee`,
  name: `${basePath}/daily-fee`,
  meta: {
    title: '每日费用',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/daily-fee.vue'], resolve)
}, {
  path: `${basePath}/income-for-dept`,
  name: `${basePath}/income-for-dept`,
  meta: {
    title: '科室收入',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/income-for-dept.vue'], resolve)
}, {
  path: `${basePath}/income-for-doctor`,
  name: `${basePath}/income-for-doctor`,
  meta: {
    title: '医生收入',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/income-for-doctor.vue'], resolve)
}, {
  path: `${basePath}/inpatient-history`,
  name: `${basePath}/inpatient-history`,
  meta: {
    title: '住院历史',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/inpatient-history.vue'], resolve)
}, {
  path: `${basePath}/Antiepidemic-query`,
  name: `${basePath}/Antiepidemic-query`,
  meta: {
    title: '疫苗登记',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/Antiepidemic-query.vue'], resolve)
}, {
  path: `${basePath}/technician-query`,
  name: `${basePath}/technician-query`,
  meta: {
    title: '医技项目查询',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/dashboard/technician-query.vue'], resolve)
}]

// var areaPatientMetaNav = {
//   title: '工作站',
//   path: '/default/workplace',
//   children: {
//     title: '手术病人',
//     path: `/default/${basePath}/theater-patient-list`
//   }
// }
// var areaPatientBaseName = 'theater-patient-manage'
// operatingTheaterRoutes.push({
//   path: `${basePath}/theater-patient-manage/:type/:inpatient_record_id/:id`, // create_user inpatient_record_id patient_id
//   name: `${basePath}/theater-patient-manage`,
//   redirect: function (route) {
//     let params = route.params
//     return `${basePath}/theater-patient-manage/${params.inpatient_record_id}/${params.id}` + '/fee'
//   },
//   meta: {
//     title: '手术病人',
//     requiresAuth: true,
//     nav: areaPatientMetaNav
//   },
//   component: resolve => require(['../views/page/operating-theater/theater-patient-manage.vue'], resolve),
//   children: [{
//     path: 'fee',
//     name: `${areaPatientBaseName}-fee`,
//     meta: {
//       title: '手术病人-手术费用',
//       requiresAuth: true,
//       nav: areaPatientMetaNav
//     },
//     component: resolve => require(['../views/page/operating-theater/components/fee.vue'], resolve)
//   }, {
//     path: 'fee-summary',
//     name: `${areaPatientBaseName}-fee-summary`,
//     meta: {
//       title: '手术病人-费用汇总',
//       requiresAuth: true,
//       nav: areaPatientMetaNav
//     },
//     component: resolve => require(['../views/page/operating-theater/components/fee-summary.vue'], resolve)
//   }, {
//     path: 'fee-cancel',
//     name: `${areaPatientBaseName}-fee-cancel`,
//     meta: {
//       title: '手术病人-退费管理',
//       requiresAuth: true,
//       nav: areaPatientMetaNav
//     },
//     component: resolve => require(['../views/page/operating-theater/components/fee-cancel.vue'], resolve)
//   }, {
//     path: 'fee-type-in',
//     name: `${areaPatientBaseName}-fee-type-in`,
//     meta: {
//       title: '手术病人-费用录入',
//       requiresAuth: true,
//       nav: areaPatientMetaNav
//     },
//     component: resolve => require(['../views/page/operating-theater/components/fee-type-in.vue'], resolve)
//   }]
// })

export default operatingTheaterRoutes
